module.exports = __webpack_public_path__ + "img/强大的研发能力.b59cad36.png";